import { render } from "./PreguntasPorUnidadYCapituloDialog.vue?vue&type=template&id=ae349ebc&scoped=true"
import script from "./PreguntasPorUnidadYCapituloDialog.vue?vue&type=script&lang=js"
export * from "./PreguntasPorUnidadYCapituloDialog.vue?vue&type=script&lang=js"

import "./PreguntasPorUnidadYCapituloDialog.vue?vue&type=style&index=0&id=ae349ebc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae349ebc"]])

export default __exports__